import React, { useEffect, useState } from 'react';
import { BadgeProps, Button, Modal, notification } from 'antd';
import { Badge, Calendar } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import UpcommingCoursesForm from './UpcommingCoursesForm';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
import Parameters from 'shared/parameters';


export default function UpcommingCourses(){
    const [value, setValue] = useState(() => dayjs('2017-01-25'));
    const [selectedValue, setSelectedValue] = useState(() => dayjs('2017-01-25'));
    const [open, setOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [event, setEvent] = useState(false);
    const { t } = useTranslation();
    const history: any = useHistory();
    const [schedules, setSchedules] = useState(null as any);
    const [fetchResult, setFetchResult] = useState("" as any);

    const refreshSchedule = async () => {
        if(Parameters.Mode === "CLIENT"){
            try {
                const params: any = {per_page: 1000};
                
                const {
                    data: {
                        data: d
                    },
                } = await API_SERVICE.fetchCourseSchedule(params);
                setSchedules(d);
                console.log('fetchCourseSchedule',d);
                
            } catch (e) {
                notification.error({
                    message: t(API_SERVICE.handleErrors(e)),
                });
            } finally {

            }
        }else{
            try {
                const params: any = {per_page: 1000};
                
                const {
                    data: {
                        data: d
                    },
                } = await API_SERVICE.fetchCourseScheduleAdmin(params);
                setSchedules(d);
                console.log('fetchCourseSchedule',d);
                
            } catch (e) {
                notification.error({
                    message: t(API_SERVICE.handleErrors(e)),
                });
            } finally {

            }
        }
    };
    useEffect(() => {
        refreshSchedule();
    }, []);
    const getListData = (value: any) => {
        // console.log('value',moment(value).format('YYYY-MM-DD'));
        
        let listData:any = [];
        schedules && schedules.map((schedule:any)=>{
            if(moment(value).format('YYYY-MM-DD') == moment(schedule?.schedule_date).format('YYYY-MM-DD')){
                listData?.push(
                    { id: schedule?.id, course_id: schedule?.course?.title, subject: schedule?.subject, message: schedule?.message, schedule_date: schedule?.schedule_date},
                );
            }
        })
        return listData || [];
      };
      
      const getMonthData = (value: Dayjs) => {
        if (value.month() === 8) {
          return 1394;
        }
      };
    const monthCellRender = (value: any) => {
        const num = getMonthData(value);
        return num ? (
          <div className="notes-month">
            <section>{num}</section>
            <span>{t('genDict.BacklogNumber')}</span>
          </div>
        ) : null;
      };
      const showModal = () => {
        setShow(true);
        setOpen(true);
      };
      const handleCancel = () => {
        setOpen(false);
        setShow(false);
      };
      const showEvent = () => {
        setEvent(true);
      };
      const hideEvent = () => {
        setEvent(false);
      };
      const onSelect = (newValue: any) => {
        setValue(newValue);
        setSelectedValue(newValue);
      };

      const dateCellRender = (value: any) => {
        const listData = getListData(value);
        return (<>
        <button role={'button'} className={'btn btn-sm btn-light small btnFormOpener'} onClick={()=>{
            Parameters.Mode === 'ADMIN' && showModal();
        }}>+</button>
          <ul className="events pl-0">
            {console.log("listData",listData)
            }
            {listData.map((item:any) => (
              <li key={item.subject}>
                <button role="button" className='btn mb-1 text-left btn-sm btn-blue small'
                    title={item.subject} 
                    style={{borderRadius:"50px",padding:"3px"}}
                    onClick={()=>{
                        setFetchResult(<>
                            <div className='mb-2'>
                                <span className='font-bold'>{t('genDict.course')}: </span>
                                <span>{item?.course_id}</span>
                            </div>
                            <div className='mb-2'>
                                <span className='font-bold'>{t('genDict.title')}: </span>
                                <span>{item?.subject}</span>
                            </div>
                            <div className='mb-2'>
                                <span className='font-bold'>{t('genDict.ScheduleDate')}: </span>
                                <span>{moment(item?.schedule_date).format("DD-MM-YYYY")}</span>
                            </div>
                            <div className='mb-2'>
                                <span className='font-bold'>{t('genDict.Message')}: </span>
                                <span>{item?.message}</span>
                            </div>
                        </>);
                        showEvent();
                    }}>
                    <span className='line-clamp-1' dangerouslySetInnerHTML={{ __html: item.subject }}/>
                </button>
              </li>
            ))}
          </ul>
          </>
        );
      };
    
      return <>
        <div className='container-fluid p-3'>
        <div className='d-md-flex' style={Parameters.Mode === 'CLIENT' ? {marginLeft:"-15px"} : {}}>
            {Parameters.Mode === 'CLIENT' && <FrontendSidebar menuSelect={9} />}
            <div className='' style={Parameters.Mode === 'CLIENT' ? {paddingLeft:"15px"} : {}}>
                {console.log('selected Date Is ',selectedValue?.format('YYYY-MM-DD'))}
                <Calendar className='trainingScheduleCalendar p-3' dateCellRender={dateCellRender} onSelect={onSelect} monthCellRender={monthCellRender} />
                {show && <Modal
                    visible={open}
                    title="Schedule a Training"
                    footer={[]}
                    onCancel={handleCancel}
                >
                    <UpcommingCoursesForm closeModal={handleCancel} getCurrSchedule={refreshSchedule} selectedDate={selectedValue?.format('YYYY-MM-DD')}/>
                </Modal>}
                <Modal
                    visible={event}
                    title="Training Schedule"
                    footer={[]}
                    onCancel={hideEvent}
                >{fetchResult}</Modal>
            </div>
        </div>
        </div>
      </>;
    
}